export const PARTICIPANTS_GET = "PARTICIPANTS_GET";
export const PARTICIPANTS_FAILURE = "PARTICIPANTS_FAILURE";
